var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProntuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45 1.8H7.2C7.2 0.807187 6.39281 0 5.4 0C4.40719 0 3.6 0.807187 3.6 1.8H1.35C0.604688 1.8 0 2.40469 0 3.15V13.05C0 13.7953 0.604688 14.4 1.35 14.4H9.45C10.1953 14.4 10.8 13.7953 10.8 13.05V3.15C10.8 2.40469 10.1953 1.8 9.45 1.8ZM5.4 1.125C5.77406 1.125 6.075 1.42594 6.075 1.8C6.075 2.17406 5.77406 2.475 5.4 2.475C5.02594 2.475 4.725 2.17406 4.725 1.8C4.725 1.42594 5.02594 1.125 5.4 1.125ZM8.1 9.675C8.1 9.79875 7.99875 9.9 7.875 9.9H6.3V11.475C6.3 11.5988 6.19875 11.7 6.075 11.7H4.725C4.60125 11.7 4.5 11.5988 4.5 11.475V9.9H2.925C2.80125 9.9 2.7 9.79875 2.7 9.675V8.325C2.7 8.20125 2.80125 8.1 2.925 8.1H4.5V6.525C4.5 6.40125 4.60125 6.3 4.725 6.3H6.075C6.19875 6.3 6.3 6.40125 6.3 6.525V8.1H7.875C7.99875 8.1 8.1 8.20125 8.1 8.325V9.675ZM8.1 4.275C8.1 4.39875 7.99875 4.5 7.875 4.5H2.925C2.80125 4.5 2.7 4.39875 2.7 4.275V3.825C2.7 3.70125 2.80125 3.6 2.925 3.6H7.875C7.99875 3.6 8.1 3.70125 8.1 3.825V4.275Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProntuario);
export default __webpack_public_path__ + "static/media/Prontuario.1430f00f5de262a26b0faf72d0802026.svg";
export { ForwardRef as ReactComponent };